import { Input } from '@/components/ui/input';
import clsx from 'clsx';
import { ComponentProps } from 'react';

export const TableFilterInputField = ({ className, ...other }: ComponentProps<typeof Input>) => {
  return <Input className={clsx('h-10 w-[150px] lg:w-[250px] xl:w-[300px] 2xl:w-[350px]', className)} {...other} />;
};
